import React from "react";
import "./Portfollio.css";
import w1 from "./assets/w1.jpg"; 
import w2 from "./assets/w2.jpg";
import w3 from "./assets/w3.jpg";
import w4 from "./assets/w4.jpg";

// Example project data
const projects = [
  {
    id: 1,
    title: "Static Website",
    img: w1,
    link: "https://www.trendythreds.in/",
  },
  {
    id: 2,
    title: "Dynamic Website",
    img: w4,
    link: "https://coaching-demo-beta.vercel.app/",
  },
  {
    id: 3,
    title: "Mobile App",
    img: w3,
    link: "#",
  },
  {
    id: 4,
    title: "School websites",
    img: w2,
    link: "#",
  },
];

// Example client reviews
const reviews = [
  {
    id: 1,
    name: "Rahul Sharma",
    feedback:
      "NextEdge built my business website and it was beyond expectations! The design is clean, and performance is top-notch.",
    avatar: "https://passport-photo.in/_next/static/media/IndianMan.99521520.png",
  },
  {
    id: 2,
    name: "Mehul Sharma",
    feedback:
      "Their mobile app solution transformed my startup idea into reality. Very professional and supportive team!",
    avatar: "https://tse1.mm.bing.net/th/id/OIP.Katwh_8zCZFjaRIB2nY7yQHaLF?pid=Api&P=0&h=220",
  },
  {
    id: 3,
    name: "Amit Patel",
    feedback:
      "Amazing poster designs for my events. Creative, eye-catching, and delivered on time. Highly recommended!",
    avatar: "https://tse1.mm.bing.net/th/id/OIP.4KhM6WeeiiGqw7hT49xZQgHaIP?pid=Api&P=0&h=220",
  },
];

const Portfolio = () => {
  return (
    <section className="portfolio" id="portfolio">
      <div className="portfolio-container">
        {/* Portfolio Section */}
        <h2 className="section-title">Our Portfolio</h2>
        <p className="section-subtitle">
          A glimpse of the work we’ve done for our clients.
        </p>

        <div className="portfolio-grid">
          {projects.map((project) => (
            <div key={project.id} className="portfolio-card">
              <img src={project.img} alt={project.title} />
              <div className="portfolio-overlay">
                <h3>{project.title}</h3>
                <a href={project.link} target="_blank" rel="noopener noreferrer">
                  View Project
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Client Reviews Section */}
        <div className="reviews-section">
          <h2 className="section-title">What Our Clients Say</h2>
          <p className="section-subtitle">
            Hear from some of our happy clients.
          </p>

          <div className="reviews-grid">
            {reviews.map((review) => (
              <div key={review.id} className="review-card">
                <img src={review.avatar} alt={review.name} className="avatar" />
                <p className="feedback">“{review.feedback}”</p>
                <h4 className="client-name">- {review.name}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
